//Funcion que devuelve la fecha actual
function getCurrentDate() {
    let currDate = new Date()
    let month = currDate.getMonth() + 1
    let day = currDate.getDate()

    if (month.toString().length == 1) {
        month = "0" + month
    }
    const date = (currDate.getFullYear() + "-" + month +
        "-" + (day.toString().length == 1 ? ("0" + day) : day))

    return date.toString()
}

//Devuelve el nombre del mes a partir de su numero de posicion en int
function guessMonthNumb(m) {
    if (m == 1) {
        return "Enero"
    } else if (m == 2) {
        return "Febrero"
    } else if (m == 3) {
        return "Marzo"
    } else if (m == 4) {
        return "Abril"
    } else if (m == 5) {
        return "Mayo"
    } else if (m == 6) {
        return "Junio"
    } else if (m == 7) {
        return "Julio"
    } else if (m == 8) {
        return "Agosto"
    } else if (m == 9) {
        return "Septiembre"
    } else if (m == 10) {
        return "Octubre"
    } else if (m == 11) {
        return "Noviembre"
    } else if (m == 12) {
        return "Diciembre"
    }
}

//Funcion que valida el email del usuario
function validateEmail(email) {
    if (email.match(/[\w\.]+@[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)+/)) {
        return true
    }
    return false
}
//Devuelve el nombre del mes a partir de su numero de posicion en string
function guessMonth(m) {
    if (m == "01" || m == "1") {
        return "enero"
    } else if (m == "02" || m == "2") {
        return "febrero"
    } else if (m == "03" || m == "3") {
        return "marzo"
    } else if (m == "04" || m == "4") {
        return "abril"
    } else if (m == "05" || m == "5") {
        return "mayo"
    } else if (m == "06" || m == "6") {
        return "junio"
    } else if (m == "07" || m == "7") {
        return "julio"
    } else if (m == "08" || m == "8") {
        return "agosto"
    } else if (m == "09" || m == "9") {
        return "septiembre"
    } else if (m == "10") {
        return "octubre"
    } else if (m == "11") {
        return "noviembre"
    } else if (m == "12") {
        return "diciembre"
    }
}
//Valida el telefono  celular
function validatePhone(phone) {
    if (phone.match(/[\d]{10}/)) {
        return true
    }
    return false
}

function getAge(d) {
    const hoy = new Date()
    const partes = d.split("-")

    const añoNac = parseInt(partes[0], 10)
    const mesNac = parseInt(partes[1], 10)
    const diaNac = parseInt(partes[2], 10)

    let edad = hoy.getFullYear() - añoNac

    // Si aún no ha cumplido años este año, le restamos 1
    if (
        hoy.getMonth() + 1 < mesNac ||
        (hoy.getMonth() + 1 === mesNac && hoy.getDate() < diaNac)
    ) {
        edad--
    }

    return edad
}

//Funcion que genera un key aleatorio
function generateKey() {
    var numbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
    var letters = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"]
    var lettersM = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"]
    var signs = ["!", "$", "&", "/", "?", "¿"]
    var key = ""

    for (let i = 0; i < 6; i++) {
        var which = Math.floor(Math.random() * 4)
        if (which == 0) {
            let val = Math.floor(Math.random() * 10)
            key += numbers[val]
        } else if (which == 1) {
            let val = Math.floor(Math.random() * 26)
            key += letters[val]
        } else if (which == 2) {
            let val = Math.floor(Math.random() * 26)
            key += lettersM[val]
        } else if (which == 3) {
            let val = Math.floor(Math.random() * 6)
            key += signs[val]
        }
    }
    return key
}

//Funcion que aumenta un mes a una fecha
function addMonthToADate(date) {
    var d = date.split("-")

    if (parseInt(d[1]) > 0 && parseInt(d[1]) < 12) {
        d[1] = (parseInt(d[1]) + 1).toString()
    } else {
        d[0] = (parseInt(d[0]) + 1).toString()
        d[1] = "1"
    }

    return d.join("-")
}

//Funcion que aumenta un año a una fecha
function addYearToADate(date) {
    var d = date.split("-")

    d[0] = (parseInt(d[0]) + 1).toString()

    return d.join("-")
}
//Compara dos fechas
function compareDates(d1, d2) {
    const [y1, m1, d_1] = d1.split("-").map(Number);
    const [y2, m2, d_2] = d2.split("-").map(Number);

    const date1 = new Date(y1, m1 - 1, d_1);
    const date2 = new Date(y2, m2 - 1, d_2);

    if (date1 < date2) return 1; // d1 es menor
    if (date1 > date2) return 2; // d1 es mayor
    return 0; // son iguales
}
//Funcion que obtiene el dia a partir de su numero de dia
function getCurrentDay(d) {
    if (d == 1) {
        return "Lunes"
    } else if (d == 2) {
        return "Martes"
    } else if (d == 3) {
        return "Miercoles"
    } else if (d == 4) {
        return "Jueves"
    } else if (d == 5) {
        return "Viernes"
    } else if (d == 6) {
        return "Sabado"
    } else if (d == 0) {
        return "Domingo"
    }
}
//Funcion que pasa la fecha de 0000-00-00 a 0 de 0 de 0000
function decomposeDate(fechaStr) {
    const diasSemana = [
        "Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"
    ]
    const meses = [
        "enero", "febrero", "marzo", "abril", "mayo", "junio",
        "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
    ]

    // Asegura que la fecha tenga el formato yyyy-mm-dd con ceros
    const [anio, mes, dia] = fechaStr.split('-').map(n => parseInt(n, 10))
    const fecha = new Date(anio, mes - 1, dia) // Date(mesIndexadoDesdeCero)

    const diaSemana = diasSemana[fecha.getDay()]
    const mesNombre = meses[fecha.getMonth()]
    const mesCapitalizado = mesNombre.charAt(0).toUpperCase() + mesNombre.slice(1)

    return `${diaSemana} ${fecha.getDate()} de ${mesCapitalizado} del ${fecha.getFullYear()}`
}

function dateToNatural(date) {
    if (!(date instanceof Date)) return "";

    const months = [
        "enero", "febrero", "marzo", "abril", "mayo", "junio",
        "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
    ];

    const day = date.getUTCDate();       // Usar UTC para evitar desfase
    const month = months[date.getUTCMonth()];
    const year = date.getUTCFullYear();

    return `${day} de ${month} del ${year}`;
}

//Funcion que nos da la fecha de una fecha dada
function validateDate(f) {
    let currDate = new Date(f)
    const date = (currDate.getFullYear() + "-" + (currDate.getMonth() + 1) +
        "-" + currDate.getDate())
    return date
}

//Funcion que valida el formulario al agregar un jugador
function validateAddPlayer(data) {
    if (!data.apellido_m_jugador || !data.apellido_p_jugador || !data.clase_jugador || !data.correo_jugador || !data.edad_jugador ||
        !data.estatura_jugador || data.inscripcion_jugador == "----/--/--" || data.mensualidad_jugador == "----/--/--" ||
        !data.nombre_jugador || !data.peso_jugador) {
        return false
    } else {
        const newData = {
            apellido_m_jugador: data.apellido_m_jugador.replace(" ", ""),
            apellido_p_jugador: data.apellido_p_jugador.replace(" ", ""),
            asistencias_jugador: data.asistencias_jugador,
            clase_jugador: data.clase_jugador,
            correo_jugador: data.correo_jugador.replace(" ", ""),
            edad_jugador: parseInt(data.edad_jugador.toString().replace(" ", "")),
            estatura_jugador: parseFloat(data.estatura_jugador.toString().replace(" ", "")),
            inscripcion_jugador: data.inscripcion_jugador,
            mensualidad_jugador: data.mensualidad_jugador,
            nombre_jugador: data.nombre_jugador.replace(" ", ""),
            peso_jugador: parseInt(data.peso_jugador.toString().replace(" ", "")),
            ranking_jugador: data.ranking_jugador
        }

        return newData
    }
}

//Funcion que devuelve la hora actual
function getCurrentTime() {
    let currDate = new Date()
    let h = currDate.getHours()
    if (h.toString().length == 1) {
        h = "0" + h
    }

    let m = currDate.getMinutes()
    if (m.toString().length == 1) {
        m = "0" + m
    }

    return h + ":" + m
}

//Funcion que transforma un numero 0000000 a 0,000,000
function formatedNumber(num) {
    return num.toLocaleString('en-US');
}

export {
    formatedNumber,
    validateEmail,
    validatePhone,
    getAge,
    generateKey,
    addYearToADate,
    addMonthToADate,
    compareDates,
    getCurrentDate,
    guessMonthNumb,
    getCurrentDay,
    decomposeDate,
    validateDate,
    validateAddPlayer,
    getCurrentTime,
    dateToNatural
}